export const ALLOWED_HOURS_IN_MINUTES = 90 * 60 * 60;
